exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-tree-browser-toggle-wrapper[data-v-924221d2] {\n  display: contents; /* Removes wrapper from layout flow */\n}\n", ""]);

